import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';

import { Util, XmStore, XmStoreUtil } from 'core/services';
import { CmsLineDataPlanCollection, CmsPlanSwitch } from 'store/cms/models';
import { LineDataPlan, PlanEligibility } from 'store/line/models';
import { AccountSummary, LineSummary } from 'store/account-summary/models';
import { PlanOption } from 'my-account/interface';
import { Title } from '@angular/platform-browser';
import { User } from 'store/user/models';

@Component({
    selector: 'plan-switch-bucket-picker',
    styleUrls: ['./bucket-picker.scss'],
    templateUrl: './bucket-picker.html',
    standalone: false
})
export class PlanSwitchBucketPickerComponent implements OnDestroy, OnInit {
    public planEligibility: PlanEligibility;
    public dataPlanCollection: CmsLineDataPlanCollection;
    public planSwitchPageData: CmsBucketSwitchCarousal;
    public firstEligiblePlan: LineDataPlan;
    public availablePlanOptions: PlanOption[];
    public lineSummary: LineSummary;
    public accountSummary: AccountSummary;
    public titleService: Title;
    public title: string;
    public showIcopPromotions: boolean = true;
    public user: User;

    private state: StateService;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(
        xmStore: XmStore, state: StateService, titleService: Title
    ) {
        Object.assign(this, { xmStore, state, title: titleService.getTitle() });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsLineDataPlanCollection>(CmsLineDataPlanCollection), (result: CmsLineDataPlanCollection) => {
            this.dataPlanCollection = result;
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<PlanEligibility>(PlanEligibility, { filters: { lineKey: this.state.params.line_id } }), (result: PlanEligibility) => {
            this.planEligibility = result;
            this.firstEligiblePlan = this.planEligibility.plans.find((plans: LineDataPlan) => plans.isEligible || plans.requiresUpgrade);
            const ineligibleInUsePlan: LineDataPlan = this.planEligibility.plans.find((plans: LineDataPlan) => plans.isIneligibleInUse);
            const selectedPlanCode: string = (this.firstEligiblePlan && this.firstEligiblePlan.planCode) || (ineligibleInUsePlan && ineligibleInUsePlan.planCode) || (this.planEligibility.plans[0].planCode);
            this.availablePlanOptions = this.planEligibility.plans.map((plan: LineDataPlan) => {
                const planData: CmsDataPlanDetails = this.dataPlanCollection.plans.find((cmsPlan: CmsDataPlanDetails) => cmsPlan.planCode.includes(plan.planCode));
                const resultData: PlanOption = { planData: plan, cmsPlanData: planData, isSelected: selectedPlanCode === plan.planCode };

                return resultData;
            }).filter((data: PlanOption) => data.cmsPlanData);
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsPlanSwitch>(CmsPlanSwitch), (result: CmsPlanSwitch) => {
            this.planSwitchPageData = result.planSwitchSlider;
            this.title = this.planSwitchPageData.pageTitle + ' | ' + this.title;
            const ariaTitle: HTMLElement = document.getElementById('title');
            ariaTitle.setAttribute('aria-label', this.title);
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            this.accountSummary = accountSummary;
            this.lineSummary = accountSummary.getLineByKey(this.state.params.line_id);
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.user = user;
        }));
    }

    public navigateTo(selectedPlan: PlanOption): void {
        if (selectedPlan) {
            this.state.go('account.activity.details.plan-switch.review', { line_id: this.state.params.line_id, plan_code: selectedPlan.planData.planCode });
        } else {
            this.state.go('account.activity.details', { line_id: this.state.params.line_id });
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
